import React, { useState } from "react";
import { useSelector } from "react-redux";
import "../../assets/css/card-detail.css";
import PrivateGigTag from "../../assets/icons/PrivateGigTag.svg";
import dayjs from "dayjs";
import { Avatar, notification, Spin } from "antd";
import { impersonate } from "../../utils/Utils";
import GreenTik from "../../assets/icons/GreenTik.svg";
import { HTTP_RESPONSE_CODES, USER_TYPE } from "../../constant";
import ModalCommon from "../common/ModalCommon";
import candidateApi from "../../features/candidate/api";

export default function CandidateCards({fetchCandidates}) {

    var localizedFormat = require("dayjs/plugin/localizedFormat");
    dayjs.extend(localizedFormat);
    const { candidates } = useSelector((state) => state.candidate);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [modalData, setModalData] = useState([]);
    const [removeCandidateLoading, setRemoveCandidateLoading] = useState({})

    const openModal = (e, data, talentId, userId) => {
        e.stopPropagation();
        setIsModalOpen(true);
        const modalData = {
          talentId: talentId,
          data: data,
          userId: userId
        }
        setModalData(modalData);
      };
    
      const redirectToCompanyProfile = (userId, companyId) => { 
        impersonate(USER_TYPE.CANDIDATE, userId, `/company-profile/${companyId}`);    
     }
    
      const handleRemoveCandidate = async (e, item, index, talentId) => {
        e.stopPropagation();
        setRemoveCandidateLoading((prev) => ({ ...prev, [index]: true }));
        const data = {
          candId: talentId,
          empId: item.AccountId
        }
        try {
          const response = await candidateApi.removeCandidate(data);
          if (response.status == HTTP_RESPONSE_CODES.SUCCESS) {
            notification.open({
              duration: 5,
              message: (
                <div
                  className="messageCon"
                >
                  <span className="tikImage" ><img src={GreenTik} /></span>
                  <p
                    className="RemovedText"
                  >
                    Removed from '{item.PvtEmpName}' private marketplace successfully
                  </p>
                </div>
              ),
              placement: "topLeft"
            });
            setIsModalOpen(false);
          }
        } catch (error) {
          notification.error({
            message: "Error",
            description: error.message
          });
        } finally {
          setRemoveCandidateLoading((prev) => ({ ...prev, [index]: false }));
          fetchCandidates();
        }
      }

    return (
        <>
            {candidates[0]?.data?.map((item) => {
                return (
                    <div key={item._id} className="manageProfileCard" onClick={() => impersonate(USER_TYPE.CANDIDATE, item._id)}>
                        <div className="manageProfileCard-e1">
                            <div className="manageProfileCard-e2">
                                <div className="manageProfileCard-e2-main">
                                    <div className="manageProfileCard-e2-image">
                                        {item?.Profiles?.PictureUrl ? (
                                            <img
                                                src={process.env.REACT_APP_S3_URL + "/" + item?.Profiles?.PictureUrl}
                                                alt=""
                                                onError={(e) => (e.target.src = `${process.env.REACT_APP_S3_URL}/content/img/no-pic.png`)}
                                            />
                                        ) : (
                                            <span className="UserCharMob">
                                                {item?.Profiles?.FirstName.slice(0, 1).toUpperCase()}
                                            </span>
                                        )}
                                    </div>
                                    <div className="manageProfileCard-e2-name">
                                        {item?.Profiles?.FirstName
                                            ? `${item?.Profiles?.FirstName} ${item?.Profiles?.LastName ? item?.Profiles?.LastName : ""
                                            }`
                                            : item?.UserName
                                                ? item?.UserName
                                                : "NA"}
                                    </div>
                                    <div
                                        className={`manageProfileCard-e3 ${item?.SoftDelete
                                            ? "Inactive"
                                            : item?.IsActive === null || item?.IsActive
                                                ? "Active"
                                                : "Inactive"
                                            } `}
                                    >
                                        {item?.SoftDelete
                                            ? "Deleted"
                                            : item.IsActive === null || item?.IsActive
                                                ? "Active"
                                                : "Inactive"}
                                    </div>
                                </div>
                                <div className="manageProfileCard-e2-field">
                                    {item?.Profiles?.CompanyName ? item?.Profiles?.CompanyName : "NA"} | {item?.Professions?.ProfessionCode}
                                </div>
                                <div className="manageProfileCard-e2-date">
                                    Created on &nbsp;
                                    {
                                        item?.LastLoginDate !== null
                                            ? dayjs(item.LastLoginDate).format("LLL").replace(",", "")
                                            : dayjs(item.Created).format("LLL").replace(",", "")
                                    }
                                    {item?.isEmployerPrivate &&
                                        <img className="ml-18" src={PrivateGigTag} alt="pvt" />}
                                </div>
                                <div className="Private-cantiner">
                                    {item.EmployeeAssociation?.length > 0
                                        ? item.EmployeeAssociation.map((data, index) => {
                                            if (index > 3) return null; // Return null instead of undefined
                                            return (
                                                <div className="PrivatePicName" onClick={(e) => openModal(e, item.EmployeeAssociation, item?.AccountId, item._id)} key={"pvt_" + index}>
                                                    {" "}
                                                    {/* Add a unique key */}
                                                    <span>
                                                        <Avatar
                                                            src={
                                                                data?.PictureUrl
                                                                    ? `${process.env.REACT_APP_S3_URL}/${data?.PictureUrl}`
                                                                    : null
                                                            }
                                                            style={{ fontSize: "14px" }}
                                                            size={24}
                                                        >
                                                            {index > 2
                                                                ? data?.length - 2
                                                                : data?.PvtEmpName
                                                                    ? data?.PvtEmpName[0]
                                                                    : "N/A"}
                                                        </Avatar>
                                                    </span>
                                                    <span className="PrivatePicName-Pvt-Name">
                                                        {data?.PvtEmpName}
                                                    </span>
                                                </div>
                                            );
                                        })
                                        : "N/A"}
                                </div>
                            </div>
                        </div>
                    </div>
                )
            })}
            <ModalCommon title="Private Employers" isModalOpen={isModalOpen} setIsModalOpen={setIsModalOpen}>
                {modalData?.data?.map((item, index) => (
                    <div key={index} className="Modal-Container">
                        <div className="sub-container">
                            <div className="namePicWrapper" onClick={() => redirectToCompanyProfile(modalData.userId, item._id)}>
                                <div className="pvtModalPic">
                                    <Avatar
                                        src={
                                            item?.PictureUrl
                                                ? `${process.env.REACT_APP_S3_URL}/${item.PictureUrl}`
                                                : null
                                        }
                                        size={24}
                                    >
                                        {item?.PvtEmpName ? item.PvtEmpName[0] : "N/A"}
                                    </Avatar>
                                </div>
                                <div
                                    className="PvtModalName"
                                >
                                    {item?.PvtEmpName}
                                </div>
                            </div>
                            <span className="btnWrapper">
                                <button
                                    className="Leave-btn"
                                    onClick={(e) => { handleRemoveCandidate(e, item, index, modalData?.talentId) }}
                                    disabled={removeCandidateLoading[index]}
                                    style={{ cursor: "pointer" }}
                                >
                                    {removeCandidateLoading[index] ? <Spin /> : "Leave from private marketplace"}
                                </button>
                            </span>
                        </div>
                    </div>
                ))}
            </ModalCommon>
        </>
    )
}